import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const StaffGradFairAddToWaitlistModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "StaffGradFairAddToWaitlistModalContainer" */
      './StaffGradFairAddToWaitlistModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
